export const SEND_SUPPORT_REQUEST = 'SEND_SUPPORT_REQUEST';
export const SEND_SUPPORT_SUCCESS = 'SEND_SUPPORT_SUCCESS';
export const SEND_SUPPORT_ERROR = 'SEND_SUPPORT_ERROR';
